import { ApButtonIcon, ApIcon, colors } from '@alixpartners/ui-components';
import * as React from 'react';
import {
  Container,
  Wrapper,
  Message,
  ProgressBar,
  IconWrapper,
} from './UploadProgress.styles';

interface IUploadProgress {
  filesCount: number;
  onCancelClick: () => void;
}

export const UploadProgress: React.FC<IUploadProgress> = ({
  filesCount,
  onCancelClick,
}) => {
  return (
    <Container>
      <IconWrapper>
        <ApIcon iconColor={colors.grey500} iconName={'cloud_upload_outlined'} />
      </IconWrapper>
      <Wrapper>
        <Message>{`${filesCount} file(s) upload processing...`}</Message>
        <ProgressBar />
      </Wrapper>
      <ApButtonIcon iconName="outline_cancel" onClick={onCancelClick} />
    </Container>
  );
};
